import { AccentColor } from "@/lib/colors";

export function QuoteSymbol({
  className = "w-10 h-10"
}: {
  className?: string;
}) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24">
      <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10H14.017zM0 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151C7.546 6.068 5.983 8.789 5.983 11H10v10H0z" />
    </svg>
  );
}

const colorClasses: Record<AccentColor, string> = {
  [AccentColor.Bubblegum]: "text-bubblegum",
  [AccentColor.Lavender]: "text-lavender",
  [AccentColor.Aegean]: "text-aegean",
  [AccentColor.Success]: "text-success",
  [AccentColor.Warning]: "text-warning",
  [AccentColor.Error]: "text-error"
};

const bgClasses: Record<AccentColor, string> = {
  [AccentColor.Bubblegum]: "bg-bubblegum",
  [AccentColor.Lavender]: "bg-lavender",
  [AccentColor.Aegean]: "bg-aegean",
  [AccentColor.Success]: "bg-success",
  [AccentColor.Warning]: "bg-warning",
  [AccentColor.Error]: "bg-error"
};

interface TestimonialProps {
  quote: string;
  author: string;
  authorInfo?: string;
  color: AccentColor;
}

export function Testimonial({
  quote,
  author,
  authorInfo,
  color
}: TestimonialProps) {
  return (
    <div className="text-center">
      <div className="relative max-w-2xl mx-auto">
        <QuoteSymbol
          className={`absolute -top-12 md:-top-6 left-0 md:-left-4 w-10 h-10 ${colorClasses[color]} opacity-50`}
        />
        <blockquote className="text-3xl md:text-4xl text-text-primary font-display font-bold tracking-tight italic text-balance">
          {quote}
        </blockquote>

        <div className="flex items-center justify-center gap-4 mt-12">
          <div
            className={`w-8 h-0.5 rounded-full ${bgClasses[color]} opacity-50`}
          />
          <div className="text-left">
            <p className="font-body text-sm font-bold text-text-primary">
              {author}
            </p>
            {authorInfo && (
              <p className="mt-1 text-text-muted text-sm">{authorInfo}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
